import React, { useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Tabs,
  Tab,
  Box,
  CircularProgress,
} from "@mui/material";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useUserQuery } from "../../../hooks/api_hooks/useUserQuery";

const ProfileLayout = () => {
  const location = useLocation();
  const { data, isLoading, isFetching } = useUserQuery();

  useEffect(() => {
    document.title = "Profile | Kloudscan";
  }, []);

  const user = data?.user;
  const personalInfo = user?.personal_information;
  const loading = isLoading || isFetching;

  const currentTab = () => {
    if (location.pathname.includes("authorization"))
      return "/profile/authorization";
    if (location.pathname.includes("subscription"))
      return "/profile/subscription";
    return "/profile/personal-information";
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ flexGrow: 1, mt: 8 }}>
      {/* Top Navigation Bar */}
      <AppBar
        position="static"
        elevation={0}
        sx={{ backgroundColor: "white", borderBottom: "1px solid #e0e0e0" }}
      >
        <Toolbar sx={{ px: { xs: 2, sm: 8 } }}>
          <Tabs
            value={currentTab()}
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontFamily:
                  '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontWeight: 500,
                color: "#444",
                minHeight: 48,
                transition: "color 0.2s ease",
              },
              "& .Mui-selected": {
                color: "#09b2f0 !important",
                fontWeight: 600,
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#09b2f0 !important",
                height: "3px",
              },
              "& .MuiTouchRipple-child": {
                backgroundColor: "#09b2f0 !important",
              },
              "& .MuiTab-root:hover": {
                color: "#09b2f0",
                opacity: 1,
              },
            }}
          >
            <Tab
              label="Personal Information"
              value="/profile/personal-information"
              component={NavLink}
              to="/profile/personal-information"
            />

            {personalInfo && (
              <Tab
                label="Authorization"
                value="/profile/authorization"
                component={NavLink}
                to="/profile/authorization"
              />
            )}

            <Tab
              label="Subscription"
              value="/profile/subscription"
              component={NavLink}
              to="/profile/subscription"
            />
          </Tabs>
        </Toolbar>
      </AppBar>

      {/* Page Content — matches Requests page layout */}
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          py: 3,
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          mt: 2,
        }}
      >
        <Box sx={{ width: "100%", maxWidth: "1440px", px: 4 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileLayout;
